 
export const initialState = {
 filterInfo:{
  cityId :0,
  companyId :0,
  },
};
 